// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://wvgoatayeagzvkpzmunv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind2Z29hdGF5ZWFnenZrcHptdW52Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM5Njg5NjgsImV4cCI6MjA1OTU0NDk2OH0.8vPQhByS7bo0iomsRX14PAvRDYvGH59tuNVqpIOT6K4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});